export const replaceURL = (valueKeyword, valueSource, valueResearchArea) => {
	const tmp = valueResearchArea.split(":")
	const Source = encodeURIComponent(valueSource).replace(/%20/g, "-")
	let Keyword = ""
	let ResearchArea
	if (valueKeyword.length > 0) {
		valueKeyword.map((keyword, i) => {
			Keyword = Keyword.concat(keyword.value.replace(/\s+/g, "-"))
			if (i !== valueKeyword.length - 1) {
				Keyword = Keyword.concat("-")
			}

			return Keyword
		})
	} else {
		Keyword = "-"
	}
	if (tmp.length === 2) {
		ResearchArea = tmp[1].replace(/\s+/g, "+")
	} else {
		ResearchArea = valueResearchArea.replace(/\s+/g, "+")
	}
	return { Keyword, Source, ResearchArea }
}

export const replaceURLBlogs = (valueHeader, valueKeyword) => {
	let Header = encodeURIComponent(valueHeader).replace(/%20/g, "-")
	return { Header }
}
